import { COLOR_PRIMARY } from "../../constants";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

interface CustomButtonProps {
  text: string;
  onClick: () => void;
}

const CustomButton: React.FC<CustomButtonProps> = ({ text, onClick }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  
  const buttonTheme = createTheme({
    shape: {
      borderRadius: 10,
    },
    palette: {
      primary: {
        main: COLOR_PRIMARY,
      },
    },
    typography: {
      button: {
        textTransform: "none",
        fontSize: isDesktop ? '1.2rem' : '1rem',
      },
    },
  });

  return (
    <ThemeProvider theme={buttonTheme}>
      <Button
        variant="contained"
        size="large"
        sx={{ 
          mt: "1rem", 
          fontSize: { xs: "1rem", md: "1.2rem" },
          py: { xs: 1, md: 1.5 },
          px: { xs: 3, md: 4 }
        }}
        onClick={onClick}
      >
        {text}
      </Button>
    </ThemeProvider>
  );
};

export default CustomButton;
